import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApAnalyticsModule } from '@ap/analytics';

import { BackgroundThemeComponent } from './background-theme.component';
import { BackgroundThemeService } from './background-theme.service';
/**
 * @name BackgroundThemeModule
 *
 * @ngdoc module
 */
@NgModule({
    declarations: [BackgroundThemeComponent],
    exports: [BackgroundThemeComponent],
    imports: [CommonModule, ApAnalyticsModule],
    providers: [BackgroundThemeService]
})
export class BackgroundThemeModule {}
